import { configureStore } from "@reduxjs/toolkit";
import divisionsReducer from "./slices/divisionsListSlice";
import rolesReducer from "./slices/rolesListSlice";
import suppliersReducer from "./slices/suppliersListSlice";
import anomaliesReducer from "./slices/anomaliesListSlice";
import documentTypesReducer from "./slices/documentTypesSlice";
import documentStatusReducer from "./slices/documentStatusSlice";
import regionsReducer from "./slices/regionsListSlice";
import intervetionTypesReducer from "./slices/intervetionTypeSlice";
import usersReducer from "./slices/usersListSlice";

const store = configureStore({
  reducer : {
      divisions: divisionsReducer,
      roles: rolesReducer,
      suppliers: suppliersReducer,
      anomalies: anomaliesReducer,
      docTypes: documentTypesReducer,
      docStatus: documentStatusReducer,
      regions: regionsReducer,
      intervetionTypes: intervetionTypesReducer,
      users: usersReducer,
  }
})

export default store;